import React, { useMemo, useState } from 'react'
import { Form } from 'react-bootstrap'
import KycButton from '../../components/form/Button/Button'
import Disclaimer from '../../components/BridgingFinance/Disclaimer'
import '../../components/kyc/kycStyle.css'
import { InputGroup, Spinner } from 'react-bootstrap'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import { useSelectedProperty } from '../../components/BridgingFinance/store'
import axios from 'axios'
import { getAPIUrl } from '../../api/API'
import { useMutation } from 'react-query'
import ScreenLayout from '../../components/layouts/ScreenLayout'
import { usePriceValue } from '../../hooks'
import { ActiveReport } from '../../components/kyc/KycPopupComponent'

import { API_ERROR_MESSAGE } from '../../utils/Constants'
import moment from 'moment'
import PropertyDetails from '../../components/ui/PropertyDetails'
import { ReactDatePicker } from '../../components/kyc/ReactDatePicker'
const BridgingFinanceSubHeader = () => {
  return (
    <span>
      If you're tired of waiting for Estate Agent's commission or the proceeds
      from <br /> a registration of a bond/sale, let{' '}
      <b>General Finance (GenFin) do the waiting</b>.
    </span>
  )
}
interface BridgeTwoProps {
  setShow: (value: boolean) => void
  setActiveReport: (value: ActiveReport) => void
  setReportTypeId: (value: number) => void
  hfOwner: string
  hfOwnerIDNoArray: string[]
  identityNumber: string
  setIdentityNumber: (value: string) => void
  hfErfNo: string
  hfAddressDetails: string
  hfSuburb: string
  hfAddress: string
  hfMunicipality: string
  date?: Date | null
  setIsError: (value: boolean) => void
  setErrorMessage: (value: string) => void
}
const BridgeTwo: React.FC<BridgeTwoProps> = ({
  setShow,
  setActiveReport,
  setIsError,
  setErrorMessage,
}) => {
  const { isShowingSalesDetails, showSalesDetails, selectedProperty } =
    useSelectedProperty()

  const {
    value: bridgingPrice,
    onChange: onBridgingPriceChange,
    parsedValue: parsedPrice,
    isComplete: isPriceComplete,
  } = usePriceValue('')

  const [_date, set_Date] = useState<Date | null>(null)
  const [showCalendar, setShowCalendar] = useState(false)

  const validateFields = (handleMissing: (missingfields: string[]) => void) => {
    const missingFields: string[] = []
    let isValid = true

    if (!isPriceComplete) {
      missingFields.push('Sales Price')
      isValid = false
    }
    if (!_date) {
      missingFields.push('Sales Date')
      isValid = false
    }
    if (handleMissing) handleMissing(missingFields)

    return isValid
  }

  const handleSave = async () => {
    const isValid = validateFields((missingFields) => {
      if (missingFields.length > 0)
        return alert(
          `Please provide the following missing fields: ${missingFields.join(
            ', ',
          )}`,
        )
    })
    if (!isValid) return
    await saveProperty()
  }

  const handleClose = () => {
    setActiveReport('BRIDGE_NEW')
  }

  const parsedDate = useMemo(() => {
    if (!_date) return ''
    //note: passing true as arg to prevent UTC conversion
    return moment(_date).format('YYYY-MM-DD')
  }, [_date])

  const onDateChange = (date: Date | null) => set_Date(date)

  const getSavePropertyArgs = (
    cmaid = 0,
    schemeNo = 0,
    sectionNo = 0,
    region: string,
  ) => {
    return {
      cmaid,
      schemeNo,
      sectionNo,
      sellingDate: parsedDate,
      price: parsedPrice,
      region,
    }
  }

  const { mutate: saveProperty, isLoading: isLoadingSaveProperty } =
    useMutation(
      ['save-property', selectedProperty],
      async () => {
        const args: any = getSavePropertyArgs(
          selectedProperty?.cmaid || 0,
          selectedProperty?.schemeNo || 0,
          selectedProperty?.sectionNo || 0,
          selectedProperty?.municipalityCode || '',
        )

        const { data } = await axios.post(
          `${getAPIUrl()}/BridgingFinance/savebridgingfinance`,
          args,
          {
            headers: {
              Authorization: `Bearer ${await sessionStorage.getItem('jwt')}`,
            },
          },
        )
        return data.data
      },
      {
        onSuccess: (data) => {
          // alert('success!')
          window.open(
            'https://generalfinance.co.za/GeneralFinance/Home?mid=Q01B',
            '_blank',
            'noopener,noreferrer',
          )
        },
        onError: (err) => {
          setIsError(true)
          setErrorMessage(API_ERROR_MESSAGE)
        },
      },
    )

  return (
    <ScreenLayout
      headerText="Bridging Finance"
      subHeaderText={<BridgingFinanceSubHeader />}
      layoutContentStyle={{ height: '100%', flex: 1 }}
    >
      {isLoadingSaveProperty && (
        <>
          <div className="spinner-container">
            <Spinner
              as="span"
              animation="border"
              variant="dark"
              role="status"
              aria-hidden="true"
            ></Spinner>
            <span> </span>
          </div>
        </>
      )}
      <Form.Group style={{ paddingTop: '5px' }}>
        <PropertyDetails />
      </Form.Group>
      {!isShowingSalesDetails && (
        <Form.Group style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
          <div style={{ flexGrow: 1 }}>
            <p
              className="lightGreyText"
              style={{ margin: 0, whiteSpace: 'nowrap', paddingTop: '15px' }}
            >
              Is this the correct Property? &nbsp;
            </p>
          </div>
          <div className="footer-btns-custom">
            <>
              <KycButton
                variant={'primary'}
                children={'YES'}
                onClick={showSalesDetails}
              />
            </>
            <KycButton
              className="m-l-10"
              onClick={handleClose}
              variant={'outline-primary'}
              children={'NO'}
              size="lg"
            />
          </div>
        </Form.Group>
      )}

      <Form.Group>
        {isShowingSalesDetails && (
          <div>
            <p>Please enter Sale details:</p>

            <InputGroup style={{ width: '70%', zIndex: 10 }}>
              <ReactDatePicker
                selected={_date}
                onChange={onDateChange}
                placeholderText="Sale Date"
              />
            </InputGroup>
            <br />
            <InputGroup style={{ display: 'flex', width: '70%', zIndex: 1 }}>
              <Form.Control
                className="custom-input"
                type="input"
                value={bridgingPrice}
                placeholder="Sale Price"
                style={{ flex: '1 1 auto', width: '1%' }}
                onChange={onBridgingPriceChange}
              />
            </InputGroup>
            <FooterButtons
              setShow={setShow}
              handleSearch={handleSave}
              searchChildren={'Submit'}
            />
          </div>
        )}
      </Form.Group>

      <Disclaimer />
    </ScreenLayout>
  )
}
export default BridgeTwo
